import * as t from 'io-ts';
import {
  Breadcrumb,
  CabTypesAvailableForRent,
  Faq,
  RouteInfo,
  TopRoutes,
  Usp,
  UspInfo
} from '../../../src/pages/runtime-typechecker';

export const ReadMoreData = t.type({
  title: t.string,
  shortDescription: t.string,
  description: t.string
});
export type ReadMoreDataType = t.TypeOf<typeof ReadMoreData>;
export const RydeHomePageTemplateData = t.type({
  templateName: t.union([t.undefined, t.string]),
  metaTitle: t.string,
  metaDescription: t.string,
  metaKeywords: t.string,
  sampleUrl: t.string,
  analytics: t.string,
  footerData: t.string,
  h1Title: t.string,
  extraInfo: t.string,
  breadcrumb: t.array(Breadcrumb),
  externalJs: t.string,
  faq: t.array(Faq),
  bannerDesktop: t.union([t.undefined, t.string]),
  bannerMobile: t.union([t.undefined, t.string]),
  descriptionInHtml: t.union([t.string, t.null, t.undefined])
});

export type RydeHomePageTemplateData = t.TypeOf<
  typeof RydeHomePageTemplateData
>;

export const CityWithRouteUrls = t.type({
  sourceCity: t.string,
  routes: t.array(RouteInfo)
});

export const PopularCitiesWithRoutes = t.array(CityWithRouteUrls);

export const RydeAssuredItem = t.type({
  rydeUspsCardInfo: UspInfo,
  uspsList: t.array(Usp)
});

export type RydeAssuredItem = t.TypeOf<typeof RydeAssuredItem>;

export const RydeHomePageDataChecker = t.type({
  pushToCache: t.boolean,
  cacheKey: t.string,
  status: t.string,
  footerData: t.string,
  popularRoutesforRydeCities: PopularCitiesWithRoutes,
  templateData: RydeHomePageTemplateData,
  cabTypesAvailableForRent: CabTypesAvailableForRent,
  popularRoutes: t.array(RouteInfo),
  topRydeRoutes: TopRoutes,
  rydeUsps: RydeAssuredItem,
  hrPackages: t.union([t.array(t.string), t.undefined])
});

export type RydeHomePageData = t.TypeOf<typeof RydeHomePageDataChecker>;
